"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_select_1 = __importDefault(require("react-select"));
const JkcMultiSelect = (props) => {
    const { name, settings, onChangeEvent } = props;
    const selectRef = (0, react_1.useRef)();
    let customControlStyles = {
        background: "transparent",
        borderColor: settings.inputStyle.borderColor ? settings.inputStyle.borderColor : "#000000",
        boxShadow: "#000000",
        border: settings.inputStyle.borderColor ? "1px solid " + settings.inputStyle.borderColor : "1px solid #D3D3D3",
        padding: "0px",
        width: "100%",
        minHeight: "40px",
        height: "auto",
        fontSize: 15,
        color: "#000000",
    };
    const selectStyle = {
        input: (provided, state) => {
            return Object.assign(Object.assign({}, provided), { padding: "0px", margin: "0px" });
        },
        valueContainer: (provided, state) => {
            return Object.assign(Object.assign({}, provided), { padding: settings.inputStyle.padding });
        },
        singleValue: (provided, state) => {
            return Object.assign(Object.assign({}, provided), { color: settings.inputStyle.color ? settings.inputStyle.color : "#000", marginLeft: "0px" });
        },
        multiValue: (provided, state) => {
            return Object.assign(Object.assign({}, provided), { color: "#000" });
        },
        multiValueLabel: (provided, state) => {
            return Object.assign(Object.assign({}, provided), { fontSize: "14px", padding: "0px" });
        },
        control: (provided, state) => {
            return Object.assign(Object.assign(Object.assign(Object.assign({}, provided), { color: state.isFocused ? "#000000" : "#000000" }), customControlStyles), { height: 'auto', ":hover": {
                    borderColor: customControlStyles.borderColor + " !important"
                } });
        },
        placeholder: (provided, state) => {
            return Object.assign(Object.assign({}, provided), { color: "#757575" });
        },
        indicatorSeparator: (provided, state) => {
            return Object.assign(Object.assign({}, provided), { display: "none" });
        },
        dropdownIndicator: (provided, state) => {
            return Object.assign(Object.assign({}, provided), { padding: "3px", marginRight: "7px", i: {
                    color: "#000000",
                } });
        },
        clearIndicator: (provided, state) => {
            return Object.assign(Object.assign({}, provided), { padding: "0px" });
        },
        menu: (provided, state) => {
            return Object.assign(Object.assign({}, provided), { color: "#000", padding: 0, marginTop: 0, fontSize: 15 });
        },
    };
    let labelStyle = {
        marginBottom: "0px",
        position: settings.isNormalLabel ? "relative" : "absolute",
    };
    let fieldStyle = {
        position: "relative",
        width: '100%',
        display: (settings.fieldTypes == 'Grid') ? 'flex' : 'block',
        borderTop: (settings.fieldTypes == 'Grid') ? '1px solid #dddddd' : 'none',
        borderBottom: (settings.fieldTypes == 'Grid') ? '1px solid #dddddd' : 'none',
        marginTop: "-1px"
    };
    if (settings.fieldTypes == 'Grid') {
        fieldStyle.alignItems = 'center';
    }
    let fieldLablStyle = {
        width: (settings.fieldTypes == 'Grid') ? '30%' : '100%',
        padding: (settings.fieldTypes == 'Grid') ? '10px 10px' : '0px'
    };
    let fieldInputStyle = {
        width: (settings.fieldTypes == 'Grid') ? '70%' : '100%',
        padding: (settings.fieldTypes == 'Grid') ? '10px 10px' : '0px',
        borderLeft: (settings.fieldTypes == 'Grid') ? '1px solid #dddddd' : 'none',
        position: 'relative'
    };
    if (settings.fieldTypes == 'Grid') {
        fieldLablStyle.textAlign = 'right';
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: fieldStyle, ref: selectRef, className: "component-area-cn" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldLablStyle }, { children: !settings.hideLabel ? ((0, jsx_runtime_1.jsx)("label", Object.assign({ style: Object.assign(Object.assign({}, labelStyle), settings.labelStyle), htmlFor: name }, { children: settings.label ? settings.label : "Label" }))) : null })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldInputStyle }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: Object.assign(Object.assign({}, settings.inputStyle), { padding: 0 }) }, { children: (0, jsx_runtime_1.jsx)(react_select_1.default, { value: settings === null || settings === void 0 ? void 0 : settings.value, className: "samrtjkc-select-container", isClearable: true, classNamePrefix: "samrtjkc-select", placeholder: settings.placeholder, isMulti: true, styles: selectStyle, options: settings.json, onChange: onChangeEvent }) })) }))] })));
};
exports.default = JkcMultiSelect;
